// roof is stored as JSON on the backend.
// So you whatever you save it will be returned.
// To make it easier to track changes in the model 
// the version field can be used.
export const getLatestSchemaVersion = (roof: drawingManagerRoof) => {
  const LATEST_SCHEMA_VERSION = 2;
  return roof.schemaVersion ? roof.schemaVersion : LATEST_SCHEMA_VERSION;
};
